import { FetchAPI } from "@renedelangel/helpers";
import { NetworkError } from "_layout/genericComponents/Metodos";

import { urlServidor, strUrlSArchivos } from '../../../helpers';
import { GET_DESEO, TABLA_DESEO  } from '../index';
import noImage from '../../../_layout/assets/svg/undraw_blank_canvas_3rbb.svg';
import { toFixed, redondeo } from "helpers/regexp";


const noTruncarDecimales = { maximumFractionDigits: 20,  style: 'currency', currency: 'MXN' };

export const getDeseo = async (variables, token) => {
    try {
        let { getDeseo } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_DESEO
        });

        return getDeseo;

    } catch({message}) { throw new Error(message); }
}

export const tablaDeseo = async (variables, token) => {
    try {
        let { filterDeseo } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: TABLA_DESEO
        });
        let listado = filterDeseo.listado;
        let listado2 = listado.map(({ imagenPortada, precioVentaOnline,  ...rest }) => {
                let imagen =   imagenPortada ? `${strUrlSArchivos}${'/public/tonline'}${imagenPortada}` : noImage;
                let precio = parseFloat(toFixed(precioVentaOnline, 2));
                precio = redondeo(precio, 2);
                precio = parseFloat(precio).toLocaleString("es-MX", noTruncarDecimales);
                return {
                    ...rest,
                    imagenPortada: imagen,
                    precioVentaOnline: precio
                }
            })
        filterDeseo.listado = listado2;
        return filterDeseo;

    } catch({message}) { throw new Error(message); }
}
